import React from 'react';
import {OVER} from "../common/static_number";

export const TagAudit = (props)=>{
    const { data:{title='已结束',index=OVER}={}  } = props;
    //0 通过 1 等待 2 未通过 3 结束
    return (
        <span style={{marginLeft: '15px',fontSize: '15px',color: ['#FBC330','#44C336','red','#999'][index]}}>{title}{title && '...'}</span>
    );
}